/**
 * Smatchy
 * The smatchy API description. Use POST /auth/login to get an access token.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ScoreRefer } from './scoreRefer';
import { QuestionDto } from './questionDto';
import { SportDiscipline } from './sportDiscipline';


export interface SportDefinition {
    _id?: string;
    id: object;
    /**
     * Internationalized text that resolves to a string
     */
    name: string;
    icon: string;
    image: string;
    unitPace?: string;
    tags: Array<string>;
    initialQuestion: QuestionDto;
    published: boolean;
    rankingType: SportDefinition.RankingTypeEnum;
    scoreRefers?: Array<ScoreRefer>;
    maxLevel: number;
    /**
     * Sub-disciplines, each with its own level questionnaire. Present on sports
     * assessed per discipline (ski); absent on single-level sports.
     */
    disciplines?: Array<SportDiscipline>;
}
export namespace SportDefinition {
    export type RankingTypeEnum = 'insideQuestion' | 'scoreRefer';
    export const RankingTypeEnum = {
        InsideQuestion: 'insideQuestion' as RankingTypeEnum,
        ScoreRefer: 'scoreRefer' as RankingTypeEnum
    };
}


